'use strict';

var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
require('react');
var parseDataAttributes = require('./parseDataAttributes-81c8dbee.js');
var _taggedTemplateLiteral = require('@babel/runtime/helpers/taggedTemplateLiteral');
var styled = require('@emotion/styled');
var react = require('@emotion/react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _taggedTemplateLiteral__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteral);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject, _templateObject2, _templateObject3;
var setLineColor = function setLineColor(theme, variant) {
  return {
    'primary-dark': theme.colors['borders-global-primary'],
    'primary-muted': theme.colors['borders-global-secondary'],
    'primary-light': theme.colors['borders-global-inverse'],
    'secondary-dark': theme.colors['borders-global-secondary'],
    'secondary-light': theme.colors['borders-global-tertiary']
  }[variant];
};
var setLabelColor = function setLabelColor(theme, variant) {
  return {
    'primary-dark': theme.colors['text-global-primary'],
    'primary-muted': theme.colors['text-global-primary'],
    'primary-light': theme.colors['text-global-inverse'],
    'secondary-dark': theme.colors['text-global-disabled'],
    'secondary-light': theme.colors['text-global-inverse']
  }[variant];
};
var DividerStyle = styled__default["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral__default["default"](["\n    --lineColor: ", ";\n    --labelColor: ", ";\n\n    align-items: center;\n    display: flex;\n    width: 100%;\n"])), function (_ref) {
  var theme = _ref.theme,
    variant = _ref.variant;
  return setLineColor(theme, variant);
}, function (_ref2) {
  var theme = _ref2.theme,
    variant = _ref2.variant;
  return setLabelColor(theme, variant);
});
var Line = styled__default["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral__default["default"](["\n    background: var(--lineColor);\n    flex-grow: 1;\n    height: 1px;\n"])));
var setLabelMargin = function setLabelMargin(position) {
  return {
    center: '0 24px',
    left: '0 24px 0 0'
  }[position];
};
var LabelStyle = styled__default["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral__default["default"](["\n    color: var(--labelColor);\n    font-size: ", ";\n    font-weight: ", ";\n    letter-spacing: 0.7px;\n    line-height: 16px;\n    margin: ", ";\n    text-transform: uppercase;\n    user-select: none;\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.ln2;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.bold;
}, function (_ref5) {
  var position = _ref5.position;
  return setLabelMargin(position);
});

var _excluded = ["variant", "className", "innerRef"],
  _excluded2 = ["label", "labelPosition", "variant", "className", "dataAttributes", "innerRef"];
var DividerNoLabel = function DividerNoLabel(_ref) {
  var variant = _ref.variant,
    className = _ref.className,
    innerRef = _ref.innerRef,
    nativeProps = _objectWithoutProperties__default["default"](_ref, _excluded);
  return react.jsx(DividerStyle, _extends__default["default"]({
    ref: innerRef,
    className: className,
    variant: variant
  }, nativeProps), react.jsx(Line, null));
};
var Divider = function Divider(_ref2) {
  var label = _ref2.label,
    _ref2$labelPosition = _ref2.labelPosition,
    labelPosition = _ref2$labelPosition === void 0 ? 'center' : _ref2$labelPosition,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'primary-dark' : _ref2$variant,
    className = _ref2.className,
    _ref2$dataAttributes = _ref2.dataAttributes,
    dataAttributes = _ref2$dataAttributes === void 0 ? {} : _ref2$dataAttributes,
    innerRef = _ref2.innerRef,
    nativeProps = _objectWithoutProperties__default["default"](_ref2, _excluded2);
  return label ? {
    center: react.jsx(DividerStyle, _extends__default["default"]({}, nativeProps, parseDataAttributes.parseDataAttributes(dataAttributes), {
      ref: innerRef,
      className: className,
      variant: variant
    }, nativeProps), react.jsx(Line, null), react.jsx(LabelStyle, {
      position: "center"
    }, label), react.jsx(Line, null)),
    left: react.jsx(DividerStyle, _extends__default["default"]({}, nativeProps, parseDataAttributes.parseDataAttributes(dataAttributes), {
      ref: innerRef,
      className: className,
      variant: variant
    }, nativeProps), react.jsx(LabelStyle, {
      position: "left"
    }, label), react.jsx(Line, null))
  }[labelPosition] : react.jsx(DividerNoLabel, _extends__default["default"]({}, nativeProps, parseDataAttributes.parseDataAttributes(dataAttributes), {
    innerRef: innerRef,
    className: className,
    variant: variant
  }, nativeProps));
};

exports.Divider = Divider;
//# sourceMappingURL=Divider-c61d5898.js.map
